/* unplugin-vue-components disabled */import { render } from "./science_m.vue?vue&type=template&id=9df7b6a4&scoped=true"
import script from "./science_m.vue?vue&type=script&lang=js"
export * from "./science_m.vue?vue&type=script&lang=js"

import "./science_m.vue?vue&type=style&index=0&id=9df7b6a4&lang=css"
import "./science_m.vue?vue&type=style&index=1&id=9df7b6a4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9df7b6a4"]])

export default __exports__